<script>
  import Select from 'svelte-select'
  import _ from 'lodash'
  export let placeholder = ''
  export let className = 'w-full'
  export let items = []
  export let name=''
  export let val = ''
  export let instanceForm = null
  export let depends = false
  export let selectedValue = false
  export let focus = () => {}
  export let onSelectCallback = () => {}
  const handleSelect = (event) => {
    val = event.detail.value || null
    onSelectCallback()
  }
  const handleClear = () => {
    val = ''
  }
</script>

<div class="input pb-1 {className}" on:click={focus}>
  <Select
    items={depends===false ? items : _.filter(items, {group: depends})}
    {selectedValue}
    {placeholder}
    isDisabled={depends===''}
    on:select={handleSelect}
    on:clear={handleClear}
    containerClasses="box-border w-full p-4 text-sm text-gray-800 placeholder-gray-400 border-orange border rounded-3xl appearance-none h-10"
    inputAttributes={{
      autocomplete:"none"
    }}
    indicatorSvg={'<svg class="mt-1 w-3" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14 12"><path fill="#E84E0F" d="M0 0l7 12 7-12H0z"/></svg>'}
    showChevron={true}
  />
  <input
    type="hidden"
    name={name}
    bind:value={val}
  >
  <div class="py-2">
    {#if $instanceForm.fields[name].errors.includes('required')}
      <span class="block w-full px-4 text-xs text-red-600 error">Campo requerido</span>
    {/if}
    {#if $instanceForm.fields[name].errors.includes('invalidLevel')}
      <span class="block w-full px-4 text-xs text-red-600 error">Estudios no compatibles</span>
    {/if}
    {#if $instanceForm.fields[name].errors.includes('invalidAge')}
      <span class="block w-full px-4 text-xs text-red-600 error">Edad no valida</span>
    {/if}
  </div>
</div>

<style>
  .input {
		--border: 1px solid #E84E0F;
		--borderRadius: 1.5rem;
		--placeholderColor: #9EA3AE;
	}
</style>